import React from "react";
import { Link } from "react-router-dom";
import Icon from "../components/Icon";


export default function HifzPage() {
  return (
    <>

      <section className="relative overflow-hidden pt-16 pb-20 md:pt-32 md:pb-40 bg-surface">
      <div className="absolute inset-0 pattern-overlay pointer-events-none"></div>
      <div className="absolute top-0 right-0 w-1/2 h-full opacity-10 pointer-events-none">

      </div>
      <div className="relative z-10 page-x max-w-max-width mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-16 items-center">
      <div className="space-y-8">
      <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-fixed text-on-primary-fixed font-label-md">
      <Icon name="stars" className="material-symbols-outlined text-[18px]" filled />
      <span>Premium Hifz Journey</span>
      </div>
      <h1 className="text-display-responsive text-primary tracking-tight">
                              Hifz Program
                          </h1>
      <p className="font-body-lg text-body-lg text-on-surface-variant max-w-lg">
                              Memorize the Quran with a structured, science-backed plan designed for long-term retention and spiritual connection.
                          </p>
      <div className="flex flex-col xs:flex-row flex-wrap gap-3 sm:gap-4 pt-4">
      <Link to="/contact" className="inline-block px-6 sm:px-8 py-3 sm:py-4 w-full sm:w-auto text-center bg-primary text-on-primary font-label-md rounded-full shadow-lg hover:shadow-xl transition-all active:scale-95">
                                  Start Free Trial
                              </Link>
      <Link to="/contact" className="inline-block px-6 sm:px-8 py-3 sm:py-4 w-full sm:w-auto text-center bg-surface text-primary border border-primary font-label-md rounded-full hover:bg-primary-fixed/20 transition-all">
                                  View Syllabus
                              </Link>
      </div>
      </div>
      <div className="relative">
      <div className="rounded-3xl overflow-hidden shadow-2xl celestial-glow">
      <img alt="Student studying Quran" className="w-full h-64 sm:h-80 md:h-[500px] object-cover" src="https://lh3.googleusercontent.com/aida-public/AB6AXuCy6YIWHbti-vzpIuOD5Ue3skEMid1B3ccZPg18ixLtCtbNhkZYoKX1mGkQmXyWwr7vKtc0BHSwt3df9qXmzNfZPUA24yfV4UgCVCI3FfpuvytdgNeSMC5ImJ7PgF9XwCugCnpOEh-KeJifRUzoRl-kfc7JkLxwfN2uAY9q42eNIEvD3mr_7j5A0UnLZ6lsOya5ifkNCSVgoiUCXRSs-X-0TRbr4UhfKCAeryVWpTh7LEV7Wo1ynm7MFHSMwHUPUfpc2eo8LzHAufi6"/>
      </div>

      <div className="absolute -bottom-10 -left-10 bg-white p-6 rounded-2xl shadow-xl border border-outline-variant/30 hidden md:block max-w-xs">
      <div className="flex items-center gap-4 mb-4">
      <div className="w-12 h-12 bg-tertiary-fixed rounded-full flex items-center justify-center">
      <Icon name="trending_up" className="material-symbols-outlined text-on-tertiary-fixed" />
      </div>
      <div>
      <div className="font-headline-md text-primary">95%</div>
      <div className="font-caption text-on-surface-variant">Retention Rate</div>
      </div>
      </div>
      <p className="font-body-md text-on-surface-variant">Our unique revision method ensures what is memorized is never forgotten.</p>
      </div>
      </div>
      </div>
      </section>

      <section className="section-y bg-surface-container-low">
      <div className="page-x max-w-max-width mx-auto">
      <div className="text-center mb-10 md:mb-16 space-y-4">
      <h2 className="text-headline-responsive text-primary">Program Outcomes</h2>
      <p className="font-body-md text-on-surface-variant max-w-2xl mx-auto">A transformative educational journey that goes beyond simple memorization to cultivate a lifelong relationship with the Divine Word.</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-gutter">

      <div className="bg-white card-pad rounded-2xl border border-outline-variant/20 shadow-sm hover:shadow-md transition-all group">
      <div className="w-14 h-14 bg-primary-fixed rounded-xl flex items-center justify-center mb-6 group-hover:rotate-6 transition-transform">
      <Icon name="menu_book" className="material-symbols-outlined text-primary" filled />
      </div>
      <h3 className="font-headline-md text-headline-md text-primary mb-3">Memorize Surahs</h3>
      <p className="font-body-md text-on-surface-variant">Systematically complete specific Surahs or the entire Quran based on your goals.</p>
      </div>

      <div className="bg-white card-pad rounded-2xl border border-outline-variant/20 shadow-sm hover:shadow-md transition-all group">
      <div className="w-14 h-14 bg-secondary-fixed rounded-xl flex items-center justify-center mb-6 group-hover:rotate-6 transition-transform">
      <Icon name="history" className="material-symbols-outlined text-secondary" filled />
      </div>
      <h3 className="font-headline-md text-headline-md text-primary mb-3">Build Revision Habits</h3>
      <p className="font-body-md text-on-surface-variant">Inculcate disciplined daily routines that make recitation a natural part of your life.</p>
      </div>

      <div className="bg-white card-pad rounded-2xl border border-outline-variant/20 shadow-sm hover:shadow-md transition-all group">
      <div className="w-14 h-14 bg-tertiary-fixed rounded-xl flex items-center justify-center mb-6 group-hover:rotate-6 transition-transform">
      <Icon name="psychology" className="material-symbols-outlined text-tertiary" filled />
      </div>
      <h3 className="font-headline-md text-headline-md text-primary mb-3">Improve Retention</h3>
      <p className="font-body-md text-on-surface-variant">Master advanced cognitive techniques to solidify your memorization long-term.</p>
      </div>

      <div className="bg-white card-pad rounded-2xl border border-outline-variant/20 shadow-sm hover:shadow-md transition-all group">
      <div className="w-14 h-14 bg-primary-fixed rounded-xl flex items-center justify-center mb-6 group-hover:rotate-6 transition-transform">
      <Icon name="record_voice_over" className="material-symbols-outlined text-primary" filled />
      </div>
      <h3 className="font-headline-md text-headline-md text-primary mb-3">Correct Recitation</h3>
      <p className="font-body-md text-on-surface-variant">Ensure every letter is pronounced with Tajweed perfection under expert supervision.</p>
      </div>
      </div>
      </div>
      </section>

      <section className="section-y bg-surface overflow-hidden">
      <div className="page-x max-w-max-width mx-auto">
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-10 md:mb-16">
      <div className="max-w-2xl">
      <h2 className="text-headline-responsive text-primary mb-4">Tailored Memorization Plans</h2>
      <p className="font-body-lg text-on-surface-variant">We understand that every student learns differently. Our Hifz programs are custom-calibrated for age, schedule, and existing knowledge.</p>
      </div>
      <div className="flex gap-4">
      <button className="p-3 border border-outline-variant rounded-full hover:bg-surface-container transition-colors">
      <Icon name="arrow_back" className="material-symbols-outlined" />
      </button>
      <button className="p-3 border border-outline-variant rounded-full hover:bg-surface-container transition-colors">
      <Icon name="arrow_forward" className="material-symbols-outlined" />
      </button>
      </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-gutter">

      <div className="md:col-span-7 bg-primary rounded-3xl p-10 text-on-primary relative overflow-hidden group">
      <div className="absolute right-0 bottom-0 opacity-10 scale-150 transform translate-x-1/4 translate-y-1/4">
      <Icon name="child_care" className="material-symbols-outlined text-[200px]" filled />
      </div>
      <div className="relative z-10">
      <span className="px-3 py-1 bg-on-primary/10 border border-on-primary/20 rounded-full font-label-md mb-6 inline-block">Ages 5-12</span>
      <h3 className="font-display-lg text-headline-lg mb-4">The Young Hafiz</h3>
      <p className="font-body-lg text-on-primary/80 mb-8 max-w-md">Focused on building love for the Quran through gamified memorization, short sessions, and frequent positive reinforcement.</p>
      <ul className="space-y-3 mb-10">
      <li className="flex items-center gap-2"><Icon name="check_circle" className="material-symbols-outlined text-[20px]" /> 30-minute daily sessions</li>
      <li className="flex items-center gap-2"><Icon name="check_circle" className="material-symbols-outlined text-[20px]" /> Focus on Juz Amma</li>
      <li className="flex items-center gap-2"><Icon name="check_circle" className="material-symbols-outlined text-[20px]" /> Interactive visual aids</li>
      </ul>
      <Link to="/contact" className="px-6 py-3 bg-white text-primary rounded-full font-bold hover:bg-tertiary-fixed transition-colors inline-block">Learn More</Link>
      </div>
      </div>

      <div className="md:col-span-5 bg-tertiary-container rounded-3xl p-10 text-on-tertiary-container relative overflow-hidden group">
      <div className="relative z-10">
      <span className="px-3 py-1 bg-white/20 border border-white/30 rounded-full font-label-md mb-6 inline-block">Ages 18+</span>
      <h3 className="text-headline-responsive mb-4">Adult Excellence</h3>
      <p className="font-body-md mb-8">Structured for busy professionals. Flexible scheduling with a focus on deep retention and meaning (Tafseer) to aid memorization.</p>
      <ul className="space-y-3 mb-8">
      <li className="flex items-center gap-2 font-medium"><Icon name="schedule" className="material-symbols-outlined" /> Evening &amp; Weekend options</li>
      <li className="flex items-center gap-2 font-medium"><Icon name="school" className="material-symbols-outlined" /> Expert Academic Mentors</li>
      </ul>
      <Link to="/pricing" className="w-full py-3 bg-on-tertiary-container text-white rounded-xl font-bold hover:opacity-90 transition-opacity inline-block text-center">Explore Plan</Link>
      </div>
      </div>

      <div className="md:col-span-12 bg-surface-container-high rounded-3xl p-10 flex flex-col md:flex-row gap-12 items-center">
      <div className="flex-1">
      <span className="px-3 py-1 bg-primary/10 text-primary border border-primary/20 rounded-full font-label-md mb-6 inline-block">Full Time</span>
      <h3 className="text-headline-responsive text-primary mb-4">Intensive Hifz Track</h3>
      <p className="font-body-lg text-on-surface-variant mb-6">Designed for those dedicated to completing the full Quran in 1-2 years through rigorous daily practice and 1-on-1 mentorship.</p>
      <div className="grid grid-cols-2 gap-4">
      <div className="bg-white p-4 rounded-xl shadow-sm border border-outline-variant/30">
      <div className="text-primary font-bold text-headline-md">2 yrs</div>
      <div className="text-caption">Avg. Completion</div>
      </div>
      <div className="bg-white p-4 rounded-xl shadow-sm border border-outline-variant/30">
      <div className="text-primary font-bold text-headline-md">1:1</div>
      <div className="text-caption">Personal Tutor</div>
      </div>
      </div>
      </div>
      <div className="flex-1 w-full h-full min-h-[300px] rounded-2xl overflow-hidden shadow-inner">
      <img alt="Intensive Hifz Class" className="w-full h-full object-cover" src="https://lh3.googleusercontent.com/aida-public/AB6AXuCw4U1o9bWCpq2OHiPMDruM_u7EZAlwAPy0KqsGRi--VTE-zNrvMqSzEkoJG7IGrGVmCimXbbdXdS8yKcCd_wJUxAFhW8ntByEIr635yC5uHkVLydfI90m0k3mrSonXlLccI2lZDKsrjA38VdkMidFwOPSdDM7AkH8w0fQCmVm7tIYFdxEWbI-anVLLUyjBqr3c1GlPUk3QDgcPR2kXmMh8iDNAua2Yqz7xZYrFOrGZHoArHHG9hog5zjfQE5B8Kf_lJlWfshWE8hyA"/>
      </div>
      </div>
      </div>
      </div>
      </section>

      <section className="section-y bg-primary text-on-primary relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">

      </div>
      <div className="page-x max-w-max-width mx-auto relative z-10">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-20 items-center">
      <div>
      <h2 className="text-display-responsive mb-8">The "Celestial Circle" Methodology</h2>
      <p className="font-body-lg text-on-primary/80 mb-12">
                                  Unlike traditional rote learning, our retention system uses spaced repetition and the three-layered revision technique to ensure that every verse is etched into the permanent memory.
                              </p>
      <div className="space-y-8">
      <div className="flex gap-6">
      <div className="flex-shrink-0 w-12 h-12 rounded-full bg-tertiary-fixed text-on-tertiary-fixed flex items-center justify-center font-bold text-xl">1</div>
      <div>
      <h4 className="font-headline-md mb-2">New Lesson (Sabaq)</h4>
      <p className="font-body-md text-on-primary/70">Focus on perfect articulation and initial memorization of new verses daily.</p>
      </div>
      </div>
      <div className="flex gap-6">
      <div className="flex-shrink-0 w-12 h-12 rounded-full bg-tertiary-fixed text-on-tertiary-fixed flex items-center justify-center font-bold text-xl">2</div>
      <div>
      <h4 className="font-headline-md mb-2">Recent Revision (Sabqi)</h4>
      <p className="font-body-md text-on-primary/70">Reciting the last 5-10 lessons to bridge the gap between short-term and long-term memory.</p>
      </div>
      </div>
      <div className="flex gap-6">
      <div className="flex-shrink-0 w-12 h-12 rounded-full bg-tertiary-fixed text-on-tertiary-fixed flex items-center justify-center font-bold text-xl">3</div>
      <div>
      <h4 className="font-headline-md mb-2">Old Revision (Manzil)</h4>
      <p className="font-body-md text-on-primary/70">Continuous rotation of all previously memorized portions to prevent any forgetfulness.</p>
      </div>
      </div>
      </div>
      </div>
      <div className="relative">
        <div className="rounded-3xl overflow-hidden shadow-2xl border-4 md:border-8 border-white/10 celestial-glow aspect-[4/3] max-w-md mx-auto">
          <img
            alt="Open Holy Quran on study desk"
            className="w-full h-full object-cover"
            src="https://lh3.googleusercontent.com/aida-public/AB6AXuDvgTtynn3TFYA71yNEoUEhkFp2MMLVoeMvUHQSBxFsdMv55iaqwdyAie0VRisR7OCB2E4uOXBFeBYApH0BNsKoVdiftepkl3xfE87XZQyvO-OypzB5T9h6hBkIBz-Lejl5qw9NO0HechCVvTw2MC4GOS10_WehLF-n-AtX8kJRjDPV2eVrbzREMgDf4JacISYGRgy0JbCJWWhLV-o_POPgud7Y80F5PImDZOw0IrvxCk2CaEbKu3Fx8CGpno3cmDw26EWp0FIger1K"
          />
        </div>
        <div className="absolute -bottom-6 -right-6 w-24 h-24 bg-tertiary-fixed opacity-20 blur-2xl rounded-full"></div>
      </div>
      </div>
      </div>
      </section>

      <section className="section-y bg-surface text-center page-x">
      <div className="max-w-3xl mx-auto space-y-8 p-12 rounded-section bg-surface-container-low border border-outline-variant shadow-sm celestial-glow">
      <h2 className="text-display-responsive text-primary">Begin Your Sacred Journey</h2>
      <p className="font-body-lg text-on-surface-variant">The path to becoming a Hafiz starts with a single step. Join hundreds of students globally in our world-class virtual academy.</p>
      <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
      <Link to="/contact" className="inline-block px-10 py-5 bg-primary text-on-primary font-bold rounded-full shadow-lg hover:scale-105 transition-transform">
                              Start Free Trial
                          </Link>
      <Link to="/contact" className="inline-block px-10 py-5 bg-white text-primary border-2 border-primary font-bold rounded-full hover:bg-primary/5 transition-colors">
                              Book a Consultation
                          </Link>
      </div>
      <p className="font-caption text-on-surface-variant">No credit card required. Cancel anytime.</p>
      </div>
      </section>
    </>
  );
}
